/* eslint no-extend-native: ["error", { "exceptions": ["String", "Number"] }] */
import { minMaxRange } from './utils'

export const DocumentFormat = (document) => {
  if (!document) return '-'

  const raw = document.toString().toUpperCase()
  // CPF: só dígitos. CNPJ: alfanumérico nas 12 primeiras posições + 2 dígitos DV
  const digitsOnly = raw.replace(/[^\d]/g, '')

  if (!raw.replace(/[^A-Z0-9]/g, '')) return '-'

  if (digitsOnly.length <= 11 && !/[A-Z]/.test(raw)) {
    return digitsOnly.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }

  const value = raw.replace(/[^A-Z0-9]/g, '')
  return value.replace(
    /^([A-Z0-9]{2})([A-Z0-9]{3})?([A-Z0-9]{3})?([A-Z0-9]{4})?(\d{2})?/,
    '$1.$2.$3/$4-$5'
  )
}

export const CpfMask = (value) =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')

export const CnpjMask = (value) => {
  // Suporta CNPJ alfanumérico (NT RFB 49/2024): 12 primeiros aceitam A-Z|0-9,
  // 2 últimos são dígitos numéricos (DV).
  const raw = value.toString().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 14)
  const head = raw.slice(0, 12)
  const tail = raw.slice(12).replace(/\D/g, '')
  let v = head + tail
  v = v.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
  v = v.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
  v = v.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2')
  v = v.replace(/([A-Z0-9]{4})(\d)/, '$1-$2')

  return v
}

export const DocumentMask = (value) => {
  // CPF (≤ 11 dígitos, sem letras) ou CNPJ (alfanumérico, > 11 chars).
  const raw = value.toString().toUpperCase()
  const hasLetter = /[A-Z]/.test(raw)
  const digitsOnly = raw.replace(/\D/g, '')

  if (!hasLetter && digitsOnly.length <= 11) {
    let v = digitsOnly
    v = v.replace(/(\d{3})(\d)/, '$1.$2')
    v = v.replace(/(\d{3})(\d)/, '$1.$2')
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
    return v
  }
  return CnpjMask(raw)
}

export const PhoneCompleteMask = (value) => {
  let v = value
  v = v.replace(/\D/g, '')

  if (v.length <= 10) {
    v = v.replace(/(\d{0})(\d)/, '($1$2')
    v = v.replace(/(\d{2})(\d)/, '$1) $2')
    v = v.replace(/(\d{4})(\d)/, '$1-$2')
  } else {
    v = v.replace(/(\d{0})(\d)/, '($1$2')
    v = v.replace(/(\d{2})(\d)/, '$1) $2')
    v = v.replace(/(\d{5})(\d)/, '$1-$2')
  }

  return v
}

export const moneyMask = (value, length = 5) => {
  if (value === null || value === undefined || value === '') {
    return 'R$ 0,00'
  }

  if (typeof value === 'number') {
    value = value.toString()
  }

  const numericValue = value.replace(/\D/g, '')

  const limitedValue = numericValue.length > length ? numericValue.slice(0, length) : numericValue

  if (!limitedValue) {
    return 'R$ 0,00'
  }

  const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  const result = new Intl.NumberFormat('pt-BR', options).format(parseFloat(limitedValue) / 100)

  return 'R$ ' + result
}

const brlFormatterNative = new Intl.NumberFormat('pt-Br', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2
})

export function formatCurrency(value) {
  return brlFormatterNative.format(value)
}

export function formatDiscountValue(value) {
  if (value < 1000) {
    return brlFormatterNative.format(value)
  } else {
    return brlFormatterNative.format(value / 100)
  }
}

export function convertToBackendValue(value) {
  if (value === null || value === undefined) {
    return 0
  }

  if (typeof value === 'number') {
    return value
  }

  if (typeof value === 'string') {
    if (value.trim() === '') {
      return 0
    }
    const cleanValue = value.replace(/[R$\s]/g, '')
    const withoutThousands = cleanValue.replace(/\./g, '')
    const decimalValue = withoutThousands.replace(',', '.')
    return parseFloat(decimalValue) || 0
  }

  return 0
}

export function convertDiscountValueToBackend(value) {
  if (value === null || value === undefined) {
    return 0
  }

  if (typeof value === 'number') {
    return value
  }

  if (typeof value === 'string') {
    const decimalValue = convertToBackendValue(value)
    return decimalValue
  }

  return 0
}

export function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export const brlFormatter = {
  format: (value) => brlFormatterNative.format(value / 100)
}

export function formatCPF(document) {
  return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export function formatCNPJ(document) {
  // Aceita CNPJ alfanumérico (12 primeiros A-Z|0-9, 2 últimos dígitos)
  return document
    .toString()
    .toUpperCase()
    .replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/, '$1.$2.$3/$4-$5')
}

export function formatCEP(document) {
  return document.replace(/(\d{5})/, '$1-')
}

export function formatPhone(document) {
  if (document.length === 8) {
    return document.replace(/(\d{4})/, '$1-')
  }
  return document.replace(/(\d{5})/, '$1-')
}

export function mask(number, mask) {
  number = number.replace(/[^0-9]/g, '')
  let numberPos = 0
  return number
    .split('')
    .map((num, i) => {
      if (mask[i + numberPos] === '0') {
        return num
      }
      return mask[i + numberPos++] + num
    })
    .join('')
}

export function onlyNumbers(value) {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  if (typeof value === 'number') {
    value = value.toString()
  }

  return value.replace(/[^0-9]/g, '')
}

export function formatNumberWithThousands(value) {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  const numericValue = onlyNumbers(value.toString())
  if (!numericValue) {
    return ''
  }

  return new Intl.NumberFormat('pt-BR').format(parseInt(numericValue, 10))
}

export function unformatNumberWithThousands(value) {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  return value.toString().replace(/\./g, '')
}
export function unmaskDocument(document) {
  return document.replace(/\.|\/|-/g, '')
}

String.prototype.nameMask = function () {
  return this.replace(/[^A-Za-zÀ-Úà-ú\s]/g, '')
}

String.prototype.emailMask = function () {
  return this.replace(/[^A-Za-z-_.@+[\]]/gi, '')
}

String.prototype.cpfMask = function () {
  return mask(this, '000.000.000-00')
}

String.prototype.cnpjMask = function () {
  return CnpjMask(this.toString())
}

String.prototype.dateMask = function () {
  const dateSplit = this.split(/-/)
  let day = dateSplit[2]
  let month = dateSplit[1]
  let year = dateSplit[0]

  if (day && day.length === 2) {
    const max = month === '02' ? 29 : parseInt(month) % 2 === 0 ? 30 : 31
    const nDay = minMaxRange(parseInt(day), 1, max)
    day = nDay < 10 ? `0${nDay}` : nDay
  }

  if (month && month.length === 2) {
    const nMonth = minMaxRange(parseInt(month), 1, 12)
    month = nMonth < 10 ? `0${nMonth}` : nMonth
  }

  if (year && year.length === 4) {
    const min = new Date().getFullYear() - 120
    const max = new Date().getFullYear() - 18
    year = minMaxRange(parseInt(year), min, max)
  }

  return mask(`${day}${month}${year}`, '00/00/0000')
}

String.prototype.zipcodeMask = function () {
  return mask(this, '00000-000')
}

String.prototype.phoneMask = function () {
  const cleanPhone = this.replace(/[^0-9]/g, '')
  return cleanPhone.length <= 8 ? mask(this, '0000-0000') : mask(this, '00000-0000')
}

Number.prototype.BRLCurrency = function () {
  return brlFormatterNative.format(this)
}
